import React, {  useEffect } from 'react';
import { useParams, useLocation } from 'react-router';
import styled from 'styled-components/macro';

import Page from '../../../components/Page';
import { State } from '../reducer';
import { getSortedCampaigns } from '../helpers';
import ActiveCampaignsList from './ActiveCampaignsList';
import ScheduledCampaignsList from './ScheduledCampaignsList';
import CompletedCampaignsList from './CompletedCampaignsList';
import { LoadingOverlay } from '../../../components/Loading';

interface CampaignsListsProps {
    campaignsListsState: State;
    fetchDiscounts: (accountId: string) => void;
    fetchCampaigns: (accountId: string) => void;
}

const CampaignsLists = (
    {
        campaignsListsState,
        fetchDiscounts,
        fetchCampaigns,
    }: CampaignsListsProps
) => {
    const { accountId } = useParams();
    const location = useLocation();

    useEffect(() => {
        if (accountId) {
            fetchDiscounts(accountId);
            fetchCampaigns(accountId);
        }
    }, [accountId, fetchDiscounts, fetchCampaigns]);

    const { discounts, campaigns } = campaignsListsState;

    if (!campaigns || !discounts) {
        return <LoadingOverlay />;
    }

    const { activeCampaigns, scheduledCampaigns, completedCampaigns } = getSortedCampaigns(discounts, campaigns);

    const campaignType = location.hash.substr(1);

    if (campaignType === 'active' || campaignType === 'scheduled' || campaignType === 'completed') {
        return (
            <Page title={''}>
                {campaignType === 'active' && <ActiveCampaignsList campaigns={activeCampaigns} />}
                {campaignType === 'scheduled' && <ScheduledCampaignsList campaigns={scheduledCampaigns} />}
                {campaignType === 'completed' && <CompletedCampaignsList campaigns={completedCampaigns} />}
            </Page>
        );
    }

    return (
        <Page title={''}>
            <CardsWrapper>
                <ActiveCampaignsList campaigns={activeCampaigns} />
                <ScheduledCampaignsList campaigns={scheduledCampaigns} />
                <CompletedCampaignsList campaigns={completedCampaigns} />
            </CardsWrapper>
        </Page>
    );
};

const CardsWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export default CampaignsLists;
